<div class="helper" (click)="help()">
  <div class="icon-help">
    <div class="container-img">
      <ion-img src="./../../../assets/icon/new-vitalia.svg"></ion-img>
    </div>
    <h3 class="title primary">
      {{'OTHER.HELP_TITLE' | translate}}
    </h3>
  </div>
</div>